import { IconButton } from '@material-ui/core'
import { Close as CloseIcon } from '@material-ui/icons'
import { SnackbarKey } from 'notistack'
import React, { FC } from 'react'
import styled from 'styled-components'

export interface DispensaryTestKitRequestToastActionsProps {
  snackbarKey: SnackbarKey
  dismissToast: (snackbarKey: SnackbarKey) => void
}

const CloseButton = styled(IconButton)`
  margin-left: 10px;

  &.MuiIconButton-root:hover {
    background-color: rgba(255, 255, 255, 0.3);
  }
`

export const getDispensaryTestKitRequestToastActions = (
  props: Omit<DispensaryTestKitRequestToastActionsProps, 'snackbarKey'>,
) => {
  const Actions = (snackbarKey: SnackbarKey) => {
    return <DispensaryTestKitRequestToastActions snackbarKey={snackbarKey} {...props} />
  }
  return Actions
}

export const DispensaryTestKitRequestToastActions: FC<
  DispensaryTestKitRequestToastActionsProps
> = ({ snackbarKey, dismissToast }) => {
  return (
    <CloseButton
      size="small"
      aria-label="close"
      style={{ color: '#000000' }}
      onClick={() => dismissToast(snackbarKey)}
    >
      <CloseIcon fontSize="small" />
    </CloseButton>
  )
}
